var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraymessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.83883 2.67169H16.1611C17.1827 2.67169 18 3.47043 18 4.46882V14.0136C18 15.012 17.1827 15.8107 16.1611 15.8107H15.1394V18.0471C15.1394 18.4864 14.6899 18.6861 14.3221 18.4864L9.62261 15.8107H2.83892C1.81728 15.8107 1 15.012 1 14.0136V4.46882C1 3.4704 1.81731 2.67169 2.83892 2.67169L2.83883 2.67169ZM16.1611 3.67011H2.83883C2.38932 3.67011 2.02152 4.02955 2.02152 4.46884V14.0136C2.02152 14.4529 2.38932 14.8124 2.83883 14.8124H9.74508C9.82677 14.8124 9.94941 14.8124 10.0311 14.8922L14.1175 17.1685V15.3314C14.1175 15.0519 14.3218 14.8122 14.6079 14.8122H16.1608C16.6103 14.8122 16.9781 14.4528 16.9781 14.0135V4.46872C16.9781 4.02943 16.6103 3.66998 16.1608 3.66998L16.1611 3.67011Z",
    fill: "#63637B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41356 7.86333C5.12755 7.86333 4.92322 7.62373 4.92322 7.34411C4.92322 7.0646 5.12754 6.82489 5.41356 6.82489H13.5867C13.8727 6.82489 14.077 7.06449 14.077 7.34411C14.077 7.62362 13.8727 7.86333 13.5867 7.86333H5.41356Z",
    fill: "#63637B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41356 11.6573C5.12755 11.6573 4.92322 11.4177 4.92322 11.1381C4.92322 10.8586 5.12754 10.6589 5.41356 10.6589H13.5867C13.8727 10.6589 14.077 10.8586 14.077 11.1381C14.077 11.4176 13.8727 11.6573 13.5867 11.6573H5.41356Z",
    fill: "#63637B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraymessage);
export default __webpack_public_path__ + "static/media/graymessage.af59fbb0154d05744ef58bcaa9e1b609.svg";
export { ForwardRef as ReactComponent };